module.exports = __webpack_public_path__ + "img/volume-2.f61b1e4c.svg";